export default {"src":"/_next/static/media/kredit2day.aa6d475e.svg","height":25,"width":123,"blurWidth":0,"blurHeight":0};